import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import actionType from '../../../Redux/Actions/ActionTypes';
import {LoadRegistrastionJournyData} from "../../../Redux/Actions/Actions";
import notify from '../../../Notifications/ToastifyActions';

function OPSUpdateTicketAgeDaysService(token,data) {
    return axios.post(`${CURRENT_API_URL}/swhelpdesk/opsUpdateTicketAgeDays`, data,{
    headers: {
        'Authorization': token,
    }
    }).then(res => {
        notify.NotifySuccess("Ticket age days has been updated successfully. Thank You!");       
        return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while updating ticket age days. please try again later.");
        return false;
    });
}

export default OPSUpdateTicketAgeDaysService;